<template>
    <v-container fluid fill-height grid-list-xs pa-0 :class="flexClass">
        <v-progress-linear :indeterminate="true" v-if="progressBarVisible" class="ma-0 pa-0 progress-top"></v-progress-linear>
        <v-layout row wrap>
            <v-flex xs12 md5>
                <v-card class="fill-height">
                    <!--
                    <v-card-title class="printable mt-2"><h2>{{ $t("pattern") }}</h2></v-card-title>
                    -->
                    <v-toolbar card prominent dense>{{ $t("showSizes") }}&nbsp;
                        <v-radio-group v-model="sizeNominal" hide-details row>
                            <v-radio :value="1" :label="$t('nominalSizes')"></v-radio>
                            <v-radio :value="0" :label="$t('actualSizes')"></v-radio>
                        </v-radio-group>
                        <!--
                        <v-spacer></v-spacer>
                        <v-switch class="mt-4" :label="$t('rotatePattern')" v-model="rotatePattern"></v-switch>
                        -->
                    </v-toolbar>
                    <v-container grid-list-md class="printable pattern-wrapper ">
                        <v-layout row wrap id="screen-info">
                            <!--
                            <v-sheet
                                class="d-flex pattern-container"
                                xs12 lg6
                                id="pattern_preview1"
                                elevation="5"
                            >
                            </v-sheet>
                            -->
                            <v-flex
                                class="pattern-container"
                                xs12
                                id="pattern_preview"
                                elevation="0"
                                ref="PatternPreview"
                            >
                                <pattern-vue
                                    id="screen-pattern"
                                    :pattern="pattern"
                                    :sizeNominal="sizeNominal"
                                    :falseCore="falseCore"
                                    :ellipseRatio="0"
                                    :rotate="0"
                                    :showDiameter="true"
                                    :showCross="showAxes"
                                    :patternSolidBG="patternSolidBG"
                                    :rotatePattern="rotatePattern"
                                    :sideSize="patternSideSize"
                                    ref="PatternVue"
                                />
                            </v-flex>

                            <v-flex
                                class="info-table-wrapper"
                                xs12
                            >
                                <table v-if="this.selectedPattern.name !== ''" class="info-table mt-1">
                                    <tr>
                                        <td>{{ $t("name") }}:</td>
                                        <td><b>{{ this.selectedPattern.name }}</b></td>
                                    </tr>
                                    <tr>
                                        <td>{{ $t("speciesAlt") }}:</td>
                                        <td><b>{{ this.selectedPattern.speciesTranslated }}</b></td>
                                    </tr>
                                    <tr>
                                        <td>{{ $t("diameterU") }}:</td>
                                        <td><b>{{ this.selectedPattern.Du }}</b></td>
                                    </tr>
                                    <tr>
                                        <td>{{ $t("pattern") }} 1:</td>
                                        <td>
                                            <b v-if="sizeNominal == 1">{{ this.$refs.PatternVue.cuttingSchemeStr[0] }}</b>
                                            <b v-else>{{ this.$refs.PatternVue.cuttingSchemeStr[2] }}</b>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{{ $t("pattern") }} 2:</td>
                                        <td>
                                            <b v-if="sizeNominal == 1">{{ this.$refs.PatternVue.cuttingSchemeStr[1] }}</b>
                                            <b v-else>{{ this.$refs.PatternVue.cuttingSchemeStr[3] }}</b>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{{ $t("createModifyDate") }}:</td>
                                        <td><b>{{ this.selectedPattern.updatedAt }}</b></td>
                                    </tr>
                                </table>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card>
            </v-flex>
            <v-flex xs12 md7 pl-0>
                <v-card class="fill-height">

                    <v-toolbar card prominent dense >
                        <v-tooltip bottom >
                            <template v-slot:activator="{ on }" >
                                <v-btn
                                    flat
                                    v-on="on"
                                    v-if="patterns.length < patternsLimit"
                                    @click="showEditPatternDlg(false)"
                                    class="ma-0"
                                >
                                    <v-icon>mdi-plus-circle-outline</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t("create") }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    flat
                                    v-on="on"
                                    v-if="patterns.length >= patternsLimit"
                                    @click="blockedCreateClick"
                                    class="ma-0"
                                >
                                    <v-icon>mdi-plus-circle-outline</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t("create") }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    flat
                                    v-on="on"
                                    @click="showEditPatternDlg(selectedPattern)"
                                    class="ma-0"
                                >
                                    <v-icon>mdi-pencil-outline</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t("edit") }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    flat
                                    v-on="on"
                                    @click="loadPatterns"
                                    class="ma-0"
                                >
                                    <v-icon>mdi-reload</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t("reload") }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    flat
                                    v-on="on"
                                    :disabled="!selectedPattern.updatedAt.length"
                                    @click="printPattern"
                                    class="ma-0"
                                >
                                    <v-icon>mdi-printer-outline</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t("print") }}</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    flat
                                    v-on="on"
                                    :disabled="!selectedPattern.updatedAt.length"
                                    @click="showCalculatePatternDlg(selectedPattern)"
                                >
                                    <v-icon>mdi-calculator</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t("calculate") }}</span>
                        </v-tooltip>
                        <!--
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <upload-btn
                                    flat
                                    noTitleUpdate
                                    title=""
                                    v-on="on"
                                    @file-update="onFileUpdate"
                                    ref="uploadButton"
                                >
                                    <template slot="icon">
                                        <v-icon>mdi-import</v-icon> {{ $t("import") }}
                                    </template>
                                </upload-btn>
                            </template>
                            <span>{{ $t("import") }}</span>
                        </v-tooltip>
                        -->

                        <upload-btn
                            flat
                            noTitleUpdate
                            title=""
                            :disabled="!acl.Create || $store.getters.subscription.settings.patterns.denyExport"
                            v-if="patterns.length < patternsLimit"
                            @file-update="onFileUpdate"
                            ref="uploadButton"
                            class="ma-0 pa-0"
                        >
                            <template slot="icon">
                                <v-icon>mdi-upload-outline</v-icon>
                            </template>
                            <span>{{ $t("import") }}</span>
                        </upload-btn>


                        <v-tooltip
                            bottom
                            :disabled="($store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp)"
                        >
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    flat
                                    v-on="on"
                                    :disabled="!acl.Create || $store.getters.subscription.settings.patterns.denyExport"
                                    v-if="patterns.length >= patternsLimit"
                                    @click="blockedImportClick"
                                >
                                    <v-icon>mdi-upload-outline</v-icon>
                                    <div
                                        v-if="($store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp)"
                                    >
                                        {{ $t("import") }}
                                    </div>
                                </v-btn>
                            </template>
                            <span>{{ $t("import") }}</span>
                        </v-tooltip>

                        <v-menu bottom offset-y>
                            <template #activator="{ on: menu }">
                                <v-tooltip
                                    bottom
                                >
                                    <template v-slot:activator="{ tooltip }">
                                        <v-btn
                                            flat
                                            v-on="{ ...tooltip, ...menu }"
                                            :disabled="!selectedPattern.updatedAt.length || !acl.Export || $store.getters.subscription.settings.patterns.denyExport"
                                            class="ma-0"
                                        >
                                            <v-icon>mdi-download-outline</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{ $t("download") }}</span>
                                </v-tooltip>
                            </template>
                            <v-list>
                                <v-list-tile
                                    v-for="(item, index) in downloadType"
                                    :key="index"
                                    @click="downloadPattern(item.value)"
                                >
                                    <v-list-tile-title>{{ item.text }}</v-list-tile-title>
                                </v-list-tile>
                            </v-list>
                        </v-menu>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    flat
                                    v-on="on"
                                    :disabled="!selectedPattern.updatedAt.length || !acl.Export || $store.getters.subscription.settings.patterns.denyExport"
                                    v-if="exportEnabled"
                                    @click="exportPattern"
                                    class="ma-0"
                                >
                                    <v-icon>mdi-database-export-outline</v-icon>
                                    <div
                                        v-if="($store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.xl)"
                                    >
                                        {{ $t("export") }}
                                    </div>
                                </v-btn>
                            </template>
                            <span>{{ $t("exportToExternalApp") }}</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    flat
                                    v-on="on"
                                    :disabled="!selectedPattern.updatedAt.length || !acl.Delete"
                                    @click="onDeleteItemClick(selectedPattern)"
                                    class="ma-0"
                                >
                                    <v-icon>mdi-delete-outline</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t("delete") }}</span>
                        </v-tooltip>
                    </v-toolbar>


                        <!--
                        <h2>{{ $t("patterns") }}</h2>
                        <v-spacer></v-spacer>

                        <v-layout row wrap>

                        </v-layout>
                        -->


                    <v-card-text>
                        <v-container fluid fill-height grid-list-xs pa-0>
                            <v-layout row wrap>
                                <v-flex xs12 md8 lg9 pb-1 pt-0 mt-0>
                                    <v-text-field
                                        class="search-field"
                                        v-model="patternSearch"
                                        prepend-icon="search"
                                        :label="$t('search')"
                                        single-line
                                        hide-details
                                        clearable
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 md8 lg9 d-flex pa-0 style="overflow-x: auto;" class="v-scrollable">
                                    <v-data-table
                                        :headers="computedHeaders"
                                        :items="filteredData"
                                        :search="patternSearch"
                                        :custom-sort="customSort"
                                        hide-actions
                                        class="dense-table"
                                    >
                                        <template v-slot:items="props">
                                            <tr
                                                @click="showPattern(props.item)"
                                                :class="{'grey darken-5': props.item.id == selectedPattern.id}"
                                            >
                                                <td class="text-xs-left">{{ props.item.speciesTranslated }}</td>
                                                <td class="text-xs-center">{{ props.item.Du }}</td>
                                                <td class="text-xs-left">{{ props.item.name }}</td>
                                                <td class="text-xs-center">{{ props.item.updatedAt }}</td>
                                                <!--
                                                <td class="justify-center layout px-0">
                                                -->
                                                    <!--
                                                    <v-icon
                                                        class="mr-2"
                                                        @click="onEditItemClick(props.item)"
                                                    >
                                                        edit
                                                    </v-icon>
                                                    -->
                                                    <!--
                                                    <v-icon
                                                        @click="exportItem(props.item)"
                                                    >
                                                        mdi-export
                                                    </v-icon>
                                                    -->
                                                    <!--
                                                    <v-icon
                                                        @click="onDeleteItemClick(props.item)"
                                                    >
                                                        delete
                                                    </v-icon>
                                                    -->
                                                <!--
                                                </td>
                                                -->
                                            </tr>
                                        </template>
                                        <template v-slot:no-results>
                                            <v-alert :value="true" color="error" icon="warning">
                                                {{ $t("youSearchFor") }}{{ patternSearch }}{{ $t("foundNoResults") }}.
                                            </v-alert>
                                        </template>
                                    </v-data-table>
                                </v-flex>
                                <v-flex xs12 md4 lg3 d-flex py-0 pl-2 class="v-scrollable border-rounded">
                                    <v-sheet
                                        class="dense border-rounded"
                                        :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                        style="overflow: auto;"
                                    >
                                        <v-expansion-panel v-model="filterPanels" expand style="overflow-y: hidden;">
                                            <v-expansion-panel-content
                                                class="grey"
                                                :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                            >
                                                <template v-slot:header>
                                                    <div class="subheading font-weight-bold">{{ $t("speciesAlt") }}</div>
                                                </template>
                                                <v-card
                                                    class="grey"
                                                    :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                                >
                                                    <v-card-text class="dense">
                                                        <v-layout row>
                                                            <v-flex xs12d-flex>
                                                                <v-checkbox
                                                                    v-for="(item, index) in speciesList"
                                                                    :key="index"
                                                                    v-model="filters.speciesTranslated"
                                                                    :value="item.titleTranslated"
                                                                    :label="item.titleTranslated"
                                                                ></v-checkbox>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-card-text>
                                                </v-card>
                                                <v-divider></v-divider>
                                            </v-expansion-panel-content>

                                            <v-expansion-panel-content
                                                class="grey"
                                                :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                            >
                                                <template v-slot:header>
                                                    <div class="subheading font-weight-bold">{{ $t("diameter") }}, {{ $t("cm") }}</div>
                                                </template>
                                                <v-card
                                                    class="grey"
                                                    :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                                >
                                                    <v-card-text class="dense">
                                                        <v-layout row>
                                                            <v-flex xs12d-flex>
                                                                <v-checkbox
                                                                    v-for="(item, index) in diametersList"
                                                                    :key="index"
                                                                    v-model="filters.Du"
                                                                    :value="item.title"
                                                                    :label="item.title.toString()"
                                                                ></v-checkbox>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-card-text>
                                                </v-card>
                                                <v-divider></v-divider>
                                            </v-expansion-panel-content>
                                        </v-expansion-panel>

                                        <v-expansion-panel v-model="filterButtons" class="filterButtons mb-0" readonly expand style="overflow-y: hidden;">
                                            <v-expansion-panel-content
                                                class="grey mb-0 py-2"
                                                :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                                hide-actions
                                            >
                                                <v-card
                                                    class="grey"
                                                    :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                                >
                                                    <v-card-text class="dense">
                                                        <v-layout row>
                                                            <v-flex xs12d-flex>
                                                                <v-btn block color="warning" @click="resetFilters">{{ $t("reset") }}</v-btn>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-card-text>
                                                </v-card>
                                            </v-expansion-panel-content>
                                        </v-expansion-panel>
                                    </v-sheet>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-flex>

            <edit-pattern-dialog  :showPatternDiameter="true"
                                  ref="EditPatternDialog"/>
            <message-box          ref="MessageBox"/>
            <message-dialog       ref="MessageDialog"/>
            <pattern-print-dialog ref="PatternPrintDialog"/>

            <v-alert
                :value="alert !== ''"
                :type="alertType"
                transition="scale-transition"
                class="bottom-alert"
            >
                {{ alert }}
            </v-alert>
        </v-layout>
    </v-container>
</template>

<script>
    import html2canvas from 'html2canvas';

    import EditPatternDialog  from "@/components/dialogs/EditPatternDialog";
    import MessageBox         from "@/components/dialogs/MessageBox";
    import MessageDialog      from "@/components/dialogs/MessageDialog";
    import PatternVue         from "@/components/patterns/PatternVue";
    import UploadButton       from "vuetify-upload-button";
    import PatternPrintDialog from "@/components/dialogs/PatternPrintDialog";

    export default {
        name: "PatternManagement",

        inject: ["theme"],

        components: {
            EditPatternDialog,
            MessageBox,
            MessageDialog,
            PatternVue,
            PatternPrintDialog,
            "upload-btn": UploadButton
            //UploadButton
        },

        data () {
            return {
                acl: {
                    Read:   false,
                    Create: false,
                    Modify: false,
                    Export: false,
                    Delete: false
                },
                alert: "",
                alertType: "success",

                breadCrumbs: [
                    { text: "Библиотека поставов", disabled: false }
                ],
                dataSavedAlert: false,
                dataSaveErrorAlert: false,
                downloadType: [
                    { text: "Файл .pattern", value: "file" },
                    { text: "Скриншот постава", value: "screen-pattern"},
                    { text: "Скриншот постава с параметрами", value: "screen-info"},
                ],
                exportEnabled: false,
                patternDeletedAlert: false,
                patternDeleteErrorAlert: false,
                dialogWatcher: null,
                falseCore: 0,
                filterButtons: 0,
                filterPanels: [true, true],
                filters: {
                    Du: [],
                    speciesTranslated: []
                },
                headers: [
                    { text: "id",                      value: "id",        align: "left",   sortable: false },
                    { text: "speciesId",               value: "speciesId", align: "left",   sortable: false },
                    { text: "dataJSON",                value: "dataJSON",  align: "left",   sortable: false },
                    { text: "Порода",                  value: "species",   align: "left",   sortable: true },
                    { text: "Учетный диаметр",         value: "Du",        align: "left",   sortable: true },
                    { text: "Имя",                     value: "name",      align: "left",   sortable: true },
                    { text: "Дата создания/изменения", value: "modDate",   align: "center", sortable: true }
                ],
                hideIDs: true,
                pattern: {},
                patterns: [],
                patternsLimit: 1,
                patternSearch: "",
                patternSideSize: 400,
                patternSolidBG: false,
                rotatePattern: false,
                showAxes: true,
                selectedPattern: {
                    name: "",
                    species: "",
                    Du: 0,
                    updatedAt: ""
                },
                boardExist: false,
                sizeNominal: 1,

                diametersList: [],
                speciesList:   [],

                loading: {
                    patterns:      false,
                    uploadPattern: false,
                    calculationResult: false
                },


            }
        },

        computed: {
            computedHeaders () {
                if (this.hideIDs) {
                    return this.headers.filter(
                        header => header.text !== "id" &&
                        header.text !== "speciesId" &&
                        header.text !== "dataJSON"
                    );
                }

                return this.headers;
            },

            filteredData () {
                return this.patterns.filter(data => {
                    return Object.keys(this.filters).every(filter => {
                        return this.filters[filter].length < 1 || this.filters[filter].includes(data[filter])
                    })
                })
            },

            flexClass () {
                return {
                    //lgUp: this.$vuetify.breakpoint.lgAndUp,
                    "md-up": this.$vuetify.breakpoint.mdAndUp
                }
            },

            progressBarVisible () {
                return this.loading.patterns || this.loading.uploadPattern || this.loading.calculationResult;
            }
        },

        async mounted () {
            if (!this.$store.getters.user.loggedIn) {
                if (!this.$noRedirect.includes(this.$router.currentRoute.path)) {
                    this.$router.push("/home");
                }
            }

            this.applyLocale();
            this.loadPatterns();

            this.$root.$on("localeChanged", () => { this.applyLocale(); });

            if (localStorage.patternsLibCurrent) {
                this.showPattern(JSON.parse(localStorage.patternsLibCurrent));
            }

            if (this.$store.getters.user.acl) {
                this.$store.getters.user.acl.forEach((aclRecord) => {
                    if (aclRecord.Module.Name == "patterns") {
                        this.acl = aclRecord;
                    }
                });
            }

            this.patternsLimit = this.$store.getters.subscription.limits.maxPatterns
                ? this.$store.getters.subscription.limits.maxPatterns
                : 1;

            let user = this.$store.getters.user;

            this.patternSolidBG = user.settings == undefined ? false : user.settings.patternSolidBG;
            this.rotatePattern  = user.settings == undefined ? false : user.settings.rotatePattern;
            this.showAxes       = user.settings == undefined ? true  : user.settings.showAxes;
            this.sizeNominal    = localStorage.sizeNominal ? parseInt(localStorage.sizeNominal) : 1;

            this.checkExport();

        },

        watch: {
            alert: function (val) {
                let component = this;
                if (val !== "") {
                    setTimeout(() => {
                        component.alert = "";
                    }, 3000);
                }
            },

            dataSavedAlert: function (val) {
                if (val) {
                    setTimeout(() => this.dataSavedAlert = false, 1500);
                }
            },

            sizeNominal: function (val) { localStorage.sizeNominal = val; },
        },

        methods: {
            /**
             * Применение локали
             */
            applyLocale () {
                this.headers = [
                    { text: "id",                        value: "id",        align: "left",   sortable: false },
                    { text: "speciesId",                 value: "speciesId", align: "left",   sortable: false },
                    { text: "dataJSON",                  value: "dataJSON",  align: "left",   sortable: false },
                    { text: this.$t("speciesAlt"),       value: "species",   align: "left",   sortable: true },
                    {
                        text: this.$t("diameter") + ", " + this.$t("cm"),
                        value: "Du",
                        align: "left",
                        sortable: true
                    },
                    //{ text: this.$t("diameterU"),        value: "Du",        align: "left",   sortable: true },
                    { text: this.$t("name"),             value: "name",      align: "left", sortable: true },
                    { text: this.$t("createModifyDate"), value: "modDate",   align: "left", sortable: true } //,
                    //{ text: this.$t("action"),           value: "action",    align: "center", sortable: false }
                ];

                this.downloadType = [
                    { text: this.$t("patternFile"), value: "file" },
                    { text: this.$t("screenPattern"), value: "screen-pattern"},
                    { text: this.$t("screenPatternWitnInfo"), value: "screen-info"}
                ];

                this.breadCrumbs = [
                    { text: this.$t("patternsLibrary"), disabled: false }
                ];

                this.patterns.forEach((pattern) => {
                    pattern.speciesTranslated = this.$t(pattern.species);
                });

                this.speciesList.forEach((item) => {
                    item.titleTranslated = this.$t(item.title);
                });

                this.filters.speciesTranslated = [];
            },

            /**
             * Отображение сообщения о блокировании создания
             */
            blockedCreateClick () {
                if (this.patterns.length >= this.patternsLimit) {
                    this.showMessageBox(this.$t("attention"), this.$t("createPatternsLimitReachedMessage"));
                }
            },

            /**
             * Отображение сообщения о блокировании загрузки
             */
            blockedImportClick () {
                if (this.patterns.length >= this.patternsLimit) {
                    this.showMessageBox(this.$t("attention"), this.$t("uploadPatternsLimitReachedMessage"));
                }
            },
            /**
             * Преобразует информацию о доске в формат для передачи во внешнее приложение
             *
             * @param {object} item Информация о доске
             *
             * @returns {object}
             */
             parseBoardInfo(item) {
                let board = {
                    id: 0,
                    lengths: [],
                    price: 0,
                    tn: 0,
                    wn: 0,
                    ts: 0,
                    ws: 0
                };

                board.id    = item.id;
                board.price = item.price;
                board.expenses = item.expenses;
                board.tn    = parseInt(item.size.slice(0, item.size.indexOf("x") - 1));
                board.wn    = parseInt(item.size.slice(item.size.indexOf("x") + 1));
                board.ts    = parseFloat(item.sawSize.slice(0, item.sawSize.indexOf("x") - 1));
                board.ws    = parseFloat(item.sawSize.slice(item.sawSize.indexOf("x") + 1));
                item.length.split(",").forEach((num) => {
                    board.lengths.push(parseFloat(num));
                });

                return board
            },

            findBoardInPattern (item, board) {
                if (item.meta.isBoard) {
                    if (board.size == `${item.tn} x ${item.wn}` && board.sawSize == `${item.ts.toFixed(1)} x ${item.ws.toFixed(1)}`) {
                            this.boardExist = true;
                        }
                } else {
                    if (item.items) {
                        item.items.forEach((subItem) => {
                            this.findBoardInPattern(subItem, board);
                        });
                    }
                }
            },

            calculate () {
                const removeMeta = (obj) => {
                    if (obj.hasOwnProperty("meta")) {
                        delete obj.meta;
                    }

                    for (let item in obj) {
                        if (typeof obj[item] === "object") { obj[item] = removeMeta(obj[item]); }
                    }

                    return obj;
                };

                const setKerf = (obj) => {
                    if (obj.hasOwnProperty("items")) {
                        obj.kerf = parseFloat(this.$refs.EditPatternDialog.kerf);
                    }

                    for (let item in obj) {
                        if (typeof obj[item] === "object") { obj[item] = setKerf(obj[item]); }
                    }

                    return obj;
                };

/**
                 * Преобразует информацию об оборудовании в формат для передачи во внешнее приложение
                 *
                 * @param {object} item Информация об оборудовании
                 *
                 * @returns {object}
                 */
                const parseEquipmentInfo = (item) => {
                    let result = {
                        name: "",
                        data: {}
                    }

                    result.name = item.name;

                    for (let param in item.data) {
                        if (param == "type") continue;
                        result.data[param] = item.data[param].val;
                    }

                    return result;
                };

                let task = {
                    speciesId: this.$refs.EditPatternDialog.speciesId,
                    lineId:    this.$refs.EditPatternDialog.equipmentId,
                    line:      [],
                    boards: {
                        central: [], //this.boardsCentral,
                        side:    [], //this.boardsSide
                    },
                    log: {
                        dTop:            this.$refs.EditPatternDialog.dTop,
                        l:               parseFloat(this.$refs.EditPatternDialog.logLength),
                        falseCore:       0,
                        taper:           this.$refs.EditPatternDialog.taper,
                        curvature:       parseFloat(this.$refs.EditPatternDialog.curvature),
                        curvatureCenter: 0.5,
                        ellipseRatio:    parseFloat(this.$refs.EditPatternDialog.ellipseRatio),
                        rotationAngle:   this.$refs.EditPatternDialog.rotate,
                        volume:          parseFloat(this.$refs.EditPatternDialog.volume)
                    },
                    useWane: this.$refs.EditPatternDialog.useWane,
                    pattern: setKerf(removeMeta(this.$refs.EditPatternDialog.pattern))
                };

                this.$refs.EditPatternDialog.boardsCentral.forEach((item) => {
                    this.boardExist = false;
                    this.findBoardInPattern(this.$refs.EditPatternDialog.$refs.PatternVue.patternData, item);
                    if (this.boardExist) {
                        task.boards.central.push(this.parseBoardInfo(item))
                    }
                });

                this.$refs.EditPatternDialog.boardsSide.forEach((item) => {
                    this.boardExist = false;
                    this.findBoardInPattern(this.$refs.EditPatternDialog.$refs.PatternVue.patternData, item);
                    if (this.boardExist) {
                        task.boards.side.push(this.parseBoardInfo(item))
                    }
                });

                this.$refs.EditPatternDialog.equipmentProfiles.forEach((profile) => {
                    if (profile.id == this.$refs.EditPatternDialog.equipmentId) {
                        profile.data.forEach((val) => {
                            task.line.push(parseEquipmentInfo(val));
                        });
                    }
                });

                this.loading.calculationResult = true;

                this.axios({
                    method: "post",
                    url: `${this.$config.apiURL}tasks/`,
                    data: {
                        type:     4,    // 1 - Оптимизация раскроя, 2 - Поиск оптимального диаметра, 3 - пересчёт постава
                        dataJSON: JSON.stringify(task)
                    },
                    withCredentials: true
                }).then(response => {
                    let taskId = response.data.task.id;
                    this.axios.get(`${this.$config.apiURL}calc/?task=${taskId}`, { withCredentials: true })
                        .then(() => {
                            this.loading.calculationResult = false;
                            this.$store.commit("setCalculationTask", {id: taskId, calculated: true});
                            this.$router.replace({ path: '/optimization' });
                        });

                }).catch(error => {
                    this.loading.calculationResult = false;
                    if (error.response && error.response.status == 402) {
                        this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                    } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                        this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                    } else if (error.response && error.response.status == 403) {
                        this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                    }
                });
            },

            /**
             * Проверка возможности экспорта
             */
            checkExport () {
                if (this.$store.getters.user.company.settings.optiSawExportURI == "") {
                    this.exportEnabled = false;
                } else {
                    this.axios.get(this.$store.getters.user.company.settings.optiSawExportURI)
                    .then(() => { this.exportEnabled = true; })
                    .catch(() => { this.exportEnabled = false; });
                }
            },

            /**
             * Сортировка таблицы
             *
             * @param {array}   items  Сортируемый список
             * @param {string}  index  Столбец сортировки
             * @param {boolean} isDesc Флаг сортировки по убыванию
             */
            customSort(items, index, isDesc) {
                items.sort((a, b) => {
                    if (index === "modDate") {
                        if (!isDesc) {
                            return a.updatedAtTimestamp < b.updatedAtTimestamp ? -1 : 1;
                        } else {
                            return a.updatedAtTimestamp > b.updatedAtTimestamp ? -1 : 1;
                        }
                    } else {
                        if (!isDesc) {
                            return a[index] < b[index] ? -1 : 1;
                        } else {
                            return a[index] > b[index] ? -1 : 1;
                        }
                    }
                });
                return items;
            },

            /**
             * Удаление постава
             *
             * @param {object} item Постав
             */
            deleteItem (item) {
                // Удаление наблюдателя если установлен
                if (this.dialogWatcher !== null) {
                    this.dialogWatcher();
                }

                this.axios({
                    method: "delete",
                    url: `${this.$config.apiURL}patterns/${item.id}/`,
                    withCredentials: true
                }).then(() => {
                    this.alertType = "success";
                    this.alert     = this.$t("patternDeleted");
                    this.loadPatterns();
                }).catch(err => {
                    if (err.response && err.response.status == 401) {
                        this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { window.location.reload(); }
                        );
                    } else if (err.response && err.response.status == 402) {
                        this.showMessageBox(this.$t("error"), this.$t("cantDeletePattern") + ". " + this.$t("subscriptionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { this.$emit("doLogout", true); }
                        );
                    } else if (err.response && err.response.status == 403 && typeof err.response.data !== "object" && err.response.data.trim() == "Access denied. Session id mismatch") {
                        this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                    } else if (err.response && err.response.status == 403) {
                        this.showMessageBox(this.$t("error"), this.$t("cantDeletePattern") + ". " + this.$t("accessDenied"));
                    } else {
                        this.alertType = "error";
                        this.alert     = this.$t("patternDeleteError");
                    }

                    this.axios({
                        method: "post",
                        url: `${this.$config.apiURL}syslog/`,
                        data: {
                            messageType: "error",
                            messageText: `PatternsManagement.vue -> deleteItem: ${JSON.stringify(err)}`
                        },
                        withCredentials: true
                    }).then(response => {
                        if (response.data.status == "failure") {
                            this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                        }
                    }).catch(error => {
                        if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                        }
                    });
                });
            },

            /**
             * Инициирует выгрузку текущего постава
             */
            downloadPattern (type) {
                if (type == "file") {
                    let data = { ...this.$refs.PatternVue.getPattern() };

                    data.species          = this.selectedPattern.species;
                    data.name             = this.selectedPattern.name;
                    data.d_u              = this.selectedPattern.Du == null   ? 0 : this.selectedPattern.Du;
                    data.d_min            = this.selectedPattern.Dmin == null ? 0 : this.selectedPattern.Dmin;
                    data.d_max            = this.selectedPattern.Dmax == null ? 0 : this.selectedPattern.Dmax;
                    data.d_limit_min      = this.selectedPattern.DLimitMin == null ? 0 : this.selectedPattern.DLimitMin;
                    data.d_limit_max      = this.selectedPattern.DLimitMax == null ? 0 : this.selectedPattern.DLimitMax;
                    data.meta_x_generator = "AVTOMATIKA-VEKTOR. SawsOptimization Web v.20220422";

                    //const blob = new Blob([data], { type: "text/plain" });
                    const blob = new Blob([JSON.stringify(data)], { type: "application/json" });
                    const evt  = document.createEvent("MouseEvents");
                    const a    = document.createElement("a");
                    a.download = this.selectedPattern.name + ".pattern"; // ".json";
                    a.href     = window.URL.createObjectURL(blob);
                    //a.dataset.downloadurl = ["text/plain", a.download, a.href].join(":");
                    a.dataset.downloadurl = ["application/json", a.download, a.href].join(":");
                    evt.initEvent("click", true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                    a.dispatchEvent(evt);
                } else {
                    // Указываем элемент, который нужно "сфотографировать"
                    const element = document.getElementById(type);
                    const rect = element.getBoundingClientRect();

                    const padding = (rect.width - this.patternSideSize) / 2;

                    // Используем html2canvas для создания изображения
                    html2canvas(element, {
                        ignoreElements: (el) => el.classList.contains('ignore-element'),
                        clip: { x: padding, y: 0, width: rect.height, height: rect.height }
                    }).then((canvas) => {
                        // Преобразуем canvas в data URL (изображение в формате PNG)
                        const imgData = canvas.toDataURL('image/png');

                        // Создаем временную ссылку для скачивания
                        const link = document.createElement('a');
                        link.href = imgData;
                        link.download = `${this.selectedPattern.name}.png`; // Имя файла

                        // Программно кликаем по ссылке, чтобы скачать файл
                        link.click();
                    });
                }
            },

            /**
             * Парсинг формата версии 1
             *
             * @param {object} data Данные в формате версии 1
             *
             * @returns {object}
             */
            convertToV1 (data) {
                let out = {};

                if (data.species   !== undefined) { out.Species     = data.species; }
                if (data.du        !== undefined) { out.Du          = data.du; }
                if (data.dlimitmin !== undefined) { out.DLimitMin   = data.dlimitmin; }
                if (data.dlimitmax !== undefined) { out.DLimitMax   = data.dlimitmax; }
                if (data.dmin      !== undefined) { out.Dmin        = data.dmin; }
                if (data.dmax      !== undefined) { out.Dmax        = data.dmax; }
                if (data.order     !== undefined) { out.order       = data.order; }
                if (data.kerf      !== undefined) { out.saw         = data.kerf; }
                if (data.vertical  !== undefined) { out.orientation = data.vertical == 1 ? "vertical" : "horizontal"; }
                if (data.ts        !== undefined) { out.fact_height = data.ts; }
                if (data.ws        !== undefined) { out.fact_width  = data.ws; }
                if (data.tn        !== undefined) { out.height      = data.tn; }
                if (data.wn        !== undefined) { out.width       = data.wn; }
                if (data.v         !== undefined) { out.v           = 1; }
                if (data.items     !== undefined) { out.items       = this.convertToV1(data.items); }

                if (data.length) { // !== undefined) {
                    let result = [];
                    data.forEach((item) => {
                        result.push(this.convertToV1(item));
                    });
                    out = result;
                //} else {
                    //out.v = 2;
                }

                return out;
            },

            /**
             * Экспорт постава
             */
            exportPattern () {
                let patternData = new FormData();

                let patternV1 = this.convertToV1(JSON.parse(this.selectedPattern.dataJSON));

                patternData.append("species",     this.selectedPattern.species);
                patternData.append("name",        this.selectedPattern.name);
                patternData.append("d_u",         this.selectedPattern.Du == null   ? 0 : this.selectedPattern.Du);
                patternData.append("d_min",       this.selectedPattern.Dmin == null ? 0 : this.selectedPattern.Dmin);
                patternData.append("d_max",       this.selectedPattern.Dmax == null ? 0 : this.selectedPattern.Dmax);
                patternData.append("d_limit_min", this.selectedPattern.DLimitMin == null ? 0 : this.selectedPattern.DLimitMin);
                patternData.append("d_limit_max", this.selectedPattern.DLimitMax == null ? 0 : this.selectedPattern.DLimitMax);
                patternData.append("pattern",     JSON.stringify(patternV1));

                this.axios({
                    method: "post",
                    url:    this.$store.getters.user.company.settings.optiSawExportURI,
                    data:   patternData, //{ pattern: this.pattern },
                    //headers: {'X-Requested-With': "X-Custom-Header"}
                    //withCredentials: true
                }).then(response => {
                    if (response.data.ErrNo == 0) {
                        this.alertType = "success";
                        this.alert     = this.$t("patternExportCompleted");
                    } else {
                        this.showMessageBox(this.$t("error"), this.$t("patternExportError"))

                        this.axios({
                            method: "post",
                            url: `${this.$config.apiURL}syslog/`,
                            data: {
                                messageType: "error",
                                messageText: `PatternsManagement.vue -> exportPattern: ${JSON.stringify(response.data)}`
                            },
                            withCredentials: true
                        }).then(response => {
                            if (response.data.status == "failure") {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        }).catch(error => {
                            if (error.response && error.response.status == 402) {
                                this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                            } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                            } else if (error.response && error.response.status == 403) {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        });

                    }
                }).catch(err => {
                    this.axios({
                        method: "post",
                        url: `${this.$config.apiURL}syslog/`,
                        data: {
                            messageType: "error",
                            messageText: `PatternsManagement.vue -> exportPattern: ${JSON.stringify(err)}`
                        },
                        withCredentials: true
                    }).then(response => {
                        if (response.data.status == "failure") {
                            this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                        }
                    }).catch(error => {
                        if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                        }
                    });

                    if (err.response && err.response.status == 402) {
                        this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                    } else if (err.response && err.response.status == 403 && typeof err.response.data !== "object" && err.response.data.trim() == "Access denied. Session id mismatch") {
                        this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                    } else if (err.response && err.response.status == 403) {
                        this.showMessageBox(this.$t("error"), this.$t("asscessDenied"));
                    }
                });
            },

            /**
             * Загрузка поставов
             */
            async loadPatterns () {
                this.loading.patterns = true;

                await this.axios.get(`${this.$config.apiURL}patterns/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let patternsInfo = response.data.patterns;

                            this.patterns    = [];

                            patternsInfo.forEach((patternInfo) => {
                                let updatedTimestamp = new Date(patternInfo.updatedAt);

                                this.patterns.push({
                                    id:        patternInfo.id,
                                    species:   patternInfo.Species.Name,
                                    speciesTranslated: this.$t(patternInfo.Species.Name),
                                    name:      patternInfo.Name,
                                    Du:        patternInfo.Du,
                                    Dmin:      patternInfo.Dmin,
                                    Dmax:      patternInfo.Dmax,
                                    DLimitMin: patternInfo.DLimitMin,
                                    DLimitMax: patternInfo.DLimitMax,
                                    dataJSON:  patternInfo.DataJSON,
                                    updatedAt: updatedTimestamp.toLocaleString(),
                                    updatedAtTimestamp: Date.parse(updatedTimestamp),
                                    //visible:    patternInfo.visible
                                });

                                let newDiameter = true;

                                this.diametersList.forEach(element => {
                                    if (element.title == patternInfo.Du) { newDiameter = false; }
                                });

                                if (newDiameter && patternInfo.Du !== null) {
                                    this.diametersList.push({
                                        id:    patternInfo.id,
                                        title: patternInfo.Du //.toString()
                                    });
                                }

                                if (this.speciesList.filter(species => species.title == patternInfo.Species.Name).length == 0) {
                                    this.speciesList.push({
                                        id:              patternInfo.Species.id,
                                        title:           patternInfo.Species.Name,
                                        titleTranslated: this.$t(patternInfo.Species.Name),
                                    });
                                }
                            });

                            this.diametersList.sort((a, b) => {
                                return parseFloat(a.title) - parseFloat(b.title);
                            });

                            this.speciesList.sort((a, b) => {
                                return a.titleTranslated > b.titleTranslated;
                            });
                        }

                        this.loading.patterns = false;
                    })
                    .catch(err => {
                        this.loading.patterns = false;

                        this.axios({
                            method: "post",
                            url: `${this.$config.apiURL}syslog/`,
                            data: {
                                messageType: "error",
                                messageText: `PatternsManagement.vue -> loadPatterns: ${JSON.stringify(err)}`
                            },
                            withCredentials: true
                        }).then(response => {
                            if (response.data.status == "failure") {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        }).catch(error => {
                            if (error.response && error.response.status == 402) {
                                this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                            } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                            } else if (error.response && error.response.status == 403) {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        });

                        if (err.response && err.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (err.response && err.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadPatternsData") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (err.response && err.response.status == 403 && typeof err.response.data !== "object" && err.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (err.response && err.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadPatternsData") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadPatternsData"));
                        }
                    });
            },

            /**
             * Обработчик нажатия кнопки удаления постава
             *
             * @param {object} item Постав
             */
            onDeleteItemClick (item) {
                /* Отслеживание ответа в диалоге "Да/Нет" */
                this.dialogWatcher = this.$watch(
                    "$refs.MessageDialog.answer",
                    (val) => {
                        if (val) { this.deleteItem(item); }
                    }
                );

                this.$refs.MessageDialog.title       = this.$t("delete");
                this.$refs.MessageDialog.messageText = this.$t("confirmPatternDelete") + " (" + item.name + ")";
                this.$refs.MessageDialog.dialog      = true;
            },

            /**
             * Обработчик нажатия кнопки редактирования постава
             *
             * @param {object} item Постав
             */
            /*
            onEditItemClick (item) {

            },
            */

            /**
             * Обработчик выбора пользователем файла для загрузки
             *
             * @param {object} file Информация о файле
             */
            onFileUpdate (file) {
                if (file !== undefined) {
                    let comp     = this;
                    let formData = new FormData();

                    formData.append("file", file);

                    this.loading.uploadPattern = true;

                    // Загрузить файл
                    this.axios({
                        method: "post",
                        headers: {
                            "Content-Type": "multipart/form-data"
                        },
                        url: `${this.$config.apiURL}patterns/upload/`,
                        data: formData,
                        withCredentials: true
                        }).then(response => {
                            if (response.status == 200 ) {
                                if (response.data.status == "attention" && response.data.message == "subscriptionLimitReached") {
                                    this.showMessageBox(this.$t("attention"), this.$t("uploadPatternsLimitReachedMessage"));
                                } else if (response.data.status == "attention") {
                                    this.showMessageBox(this.$t("error"), this.$t("cantUploadPattern"));
                                } else {
                                    comp.alertType = "success";
                                    comp.alert     = comp.$t("dataSaved");
                                    comp.loadPatterns();
                                }
                            }

                            this.loading.uploadPattern = false;
                        }).catch(err => {
                            this.loading.uploadPattern = false;

                            this.axios({
                                method: "post",
                                url: `${this.$config.apiURL}syslog/`,
                                data: {
                                    messageType: "error",
                                    messageText: `PatternsManagement.vue -> onFileUpdate: ${JSON.stringify(err)}`
                                },
                                withCredentials: true
                            }).then(response => {
                                if (response.data.status == "failure") {
                                    this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                                }
                            }).catch(error => {
                                if (error.response && error.response.status == 402) {
                                    this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                                } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                    this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                                } else if (error.response && error.response.status == 403) {
                                    this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                                }
                            });

                            if (err.response && err.response.status == 401) {
                                this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                                // Удаление наблюдателя если установлен
                                if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                                // Отслеживание нажатия кнопки ok в диалоге
                                this.dialogWatcher = this.$watch(
                                    "$refs.MessageBox.dialog",
                                    () => { window.location.reload(); }
                                );
                            } else if (err.response && err.response.status == 402) {
                                this.showMessageBox(this.$t("error"), this.$t("cantUploadFile") + ". " + this.$t("subscriptionExpired"));

                                // Удаление наблюдателя если установлен
                                if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                                // Отслеживание нажатия кнопки ok в диалоге
                                this.dialogWatcher = this.$watch(
                                    "$refs.MessageBox.dialog",
                                    () => { this.$emit("doLogout", true); }
                                );
                            } else if (err.response && err.response.status == 403 && typeof err.response.data !== "object" && err.response.data.trim() == "Access denied. Session id mismatch") {
                                this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                            } else if (err.response && err.response.status == 403) {
                                this.showMessageBox(this.$t("error"), this.$t("cantUploadFile") + ". " + this.$t("accessDenied"));
                            } else {
                                comp.alertType = "error";
                                comp.alert     = comp.$t("dataSaveError");
                            }
                        });

                    this.$refs.uploadButton.clear();
                }
            },

            /**
             * Парсинг формата версии 1
             *
             * @param {object} data Данные в формате версии 1
             *
             * @returns {object}
             */
            parseV1 (data) {
                let out = {};

                if (data.Species     !== undefined) { out.species   = data.Species; }
                if (data.Du          !== undefined) { out.du        = data.Du; }
                if (data.DLimitMin   !== undefined) { out.dlimitmin = data.DLimitMin; }
                if (data.DLimitMax   !== undefined) { out.dlimitmax = data.DLimitMax; }
                if (data.Dmin        !== undefined) { out.dmin      = data.Dmin; }
                if (data.Dmax        !== undefined) { out.dmax      = data.Dmax; }
                if (data.order       !== undefined) { out.order     = data.order; }
                if (data.saw         !== undefined) { out.kerf      = data.saw; }
                if (data.orientation !== undefined) { out.vertical  = data.orientation == "vertical" ? 1 : 0; }
                if (data.fact_height !== undefined) { out.ts        = data.fact_height; }
                if (data.fact_width  !== undefined) { out.ws        = data.fact_width; }
                if (data.height      !== undefined) { out.tn        = data.height; }
                if (data.width       !== undefined) { out.wn        = data.width; }
                if (data.items       !== undefined) { out.items     = this.parseV1(data.items); }

                if (data.length) { // !== undefined) {
                    let result = [];
                    data.forEach((item) => {
                        result.push(this.parseV1(item));
                    });
                    out = result;
                } else {
                    out.v = 2;
                }

                return out;
            },

            /**
             * Печать постава
             */
            printPattern () {
                this.$refs.PatternPrintDialog.pattern         = this.pattern;
                this.$refs.PatternPrintDialog.sizeNominal     = this.sizeNominal;
                this.$refs.PatternPrintDialog.falseCore       = this.falseCore;
                this.$refs.PatternPrintDialog.logInfo         = false;
                this.$refs.PatternPrintDialog.selectedPattern = this.selectedPattern;
                this.$refs.PatternPrintDialog.cuttingScheme   = this.$refs.PatternVue.cuttingSchemeStr;
                this.$refs.PatternPrintDialog.dialog          = true;
            },

            /**
             * Сброс фильтров
             */
            resetFilters () {
                this.filters.Du = [];
                this.filters.speciesTranslated = [];
            },

            /*
            exportItem (item) {
                window.open(${this.$config.apiURL} + "patterns/download/" + item.id, "_blank");
            },
            */

            /**
             * Отображение диалога редактирования постава
             *
             * @param {object} pattern Редактируемый постав
             */
            showEditPatternDlg (pattern = false) {
                let patternId = pattern ? pattern.id : -1;

                if (pattern) {
                    let parsedPattern   = JSON.parse(pattern.dataJSON);
                    let selectedSpecies = this.speciesList.filter(species => species.title == pattern.species);

                    parsedPattern = parsedPattern.v == 2
                        ? parsedPattern
                        : this.parseV1(parsedPattern);
                    parsedPattern.id = this.selectedPattern.id;

                    this.$refs.EditPatternDialog.name      = pattern.name;
                    this.$refs.EditPatternDialog.speciesId = selectedSpecies.length > 0 && selectedSpecies[0].id !== undefined
                        ? selectedSpecies[0].id
                        : 1;
                    this.$refs.EditPatternDialog.dU      = pattern.Du;
                    this.$refs.EditPatternDialog.pattern = parsedPattern; //JSON.parse(pattern.dataJSON); //pattern;
                    this.$refs.EditPatternDialog.parsedPattern = parsedPattern;
                } else {
                    let emptyPattern = {
                        dlimitmin: 140,
                        dlimitmax: 220,
                        dmin:      140,
                        dmax:      220,
                        du:        16,
                        kerf:      5,
                        order:     1,
                        species:   "spruce",
                        v:         2,
                        vertical:  0,
                        meta: {
                            isBoard:     false,
                            isVertical:  true,
                            showNominal: true,
                            xSize: 104,
                            ySize: 103
                        },
                        items: []
                    };
                    this.$refs.EditPatternDialog.name      = pattern.name;
                    this.$refs.EditPatternDialog.speciesId = 1;
                    this.$refs.EditPatternDialog.dU        = pattern.Du;
                    this.$refs.EditPatternDialog.pattern   = { ...emptyPattern };
                    this.$refs.EditPatternDialog.$refs.PatternVue.reset();
                }

                this.$refs.EditPatternDialog.dTop      = undefined;
                this.$refs.EditPatternDialog.dBottom   = undefined;

                // Удаление наблюдателя если установлен
                if (this.dialogWatcher !== null) {
                    this.dialogWatcher();
                }

                //Отслеживание изменение списка поставов
                this.dialogWatcher = this.$watch(
                    "$refs.EditPatternDialog.dialog",
                    async (val) => {
                        if (!val) {
                            await this.loadPatterns();

                            if (patternId != -1) {
                                this.showPattern(this.patterns.filter(pattern => pattern.id == patternId)[0]);
                            } else {
                                this.showPattern(this.patterns[this.patterns.length-1]);
                            }
                        }
                    }
                );

                this.$refs.EditPatternDialog.calculationForm = false;
                this.$refs.EditPatternDialog.dialog = true;
            },

            showCalculatePatternDlg (pattern) {
                let parsedPattern   = JSON.parse(pattern.dataJSON);
                let selectedSpecies = this.speciesList.filter(species => species.title == pattern.species);

                this.$refs.EditPatternDialog.speciesId = selectedSpecies.length > 0 && selectedSpecies[0].id !== undefined
                        ? selectedSpecies[0].id
                        : 1;
                this.$refs.EditPatternDialog.loadLumber();
                this.$refs.EditPatternDialog.pattern = parsedPattern;
                this.$refs.EditPatternDialog.parsedPattern = parsedPattern;

                this.$refs.EditPatternDialog.taper         = 8;
                this.$refs.EditPatternDialog.logLength     = 5;
                this.$refs.EditPatternDialog.dTop          = this.$refs.PatternVue.diameter;
                this.$refs.EditPatternDialog.dBottom       = this.$refs.PatternVue.diameter + (8*5);
                this.$refs.EditPatternDialog.curvature     = 0;
                this.$refs.EditPatternDialog.ellipseRatio  = 0;
                this.$refs.EditPatternDialog.rotate        = 0;

                // Удаление наблюдателя если установлен
                if (this.dialogWatcher !== null) {
                    this.dialogWatcher();
                }

                //Отслеживание изменение списка поставов
                this.dialogWatcher = this.$watch(
                    "$refs.EditPatternDialog.recalculate",
                    async (val) => {
                        if (val) {
                            this.calculate();
                        }
                    }
                );

                this.$refs.EditPatternDialog.calculationForm = true;
                this.$refs.EditPatternDialog.dialog = true;
            },

            /**
             * Отображение сообщения
             *
             * @param {string} title       Заголовок
             * @param {string} messageText Текст сообщения
             */
            showMessageBox (title, messageText) {
                this.$refs.MessageBox.title       = title;
                this.$refs.MessageBox.messageText = messageText;
                this.$refs.MessageBox.dialog      = true;
            },

            /**
             * Отображение постава
             *
             * @param {object} data Данные о поставе
             */
            showPattern (data) {
                /*
                $("#pattern_preview").empty();
                let pattern = new Pattern(JSON.parse(data.dataJSON), $("#pattern_preview1"));
                */

                this.selectedPattern = data;
                localStorage.patternsLibCurrent = JSON.stringify(this.selectedPattern); //data);
                this.pattern = JSON.parse(data.dataJSON); //data;
            }
        }
    }
</script>

<style lang="sass" scoped>
    #app.theme--light .upload-btn .v-btn--disabled .v-btn__content
        color: rgba(0,0,0,0.26) !important

    #app.theme--dark .upload-btn .v-btn--disabled .v-btn__content
        color: rgba(255,255,255,0.3) !important

    .patterns-card
        overflow-y: auto
        max-height: calc(100dvh - 48px)

    .pattern-container
        &-container
            box-sizing: border-box
            /* border: 1px solid #aaa */
            display: inline-block
            padding: 8px
            margin: 0 auto

    .bottom-alert
        position: fixed
        bottom: 0
        right: 0
        z-index: 999

    .container.md-up
        .v-scrollable
            overflow-y: auto
            max-height: calc(100dvh - 160px)

        .pattern-wrapper.v-scrollable
            overflow-y: auto
            max-height: calc(93vh - 145px)

    .v-btn
        min-width: 70px

    .info-table-wrapper
        display: flex
        justify-content: center

    .info-table
        &-wrapper
            margin: 0 auto
        td
            padding: 0 5px

    .search-field
        padding: 0
        margin-top: 0
        margin-bottom: 6px
</style>
